export default "__VITE_ASSET__54U7i0YY__"